export default "__VITE_ASSET__DkACZxvG__"